// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__XiChZ","colCheckbox":"styles_colCheckbox__1Pe59"};